import axios from "../../utils/axios";

export const getVideos = async (page, limit, tags, search, author) => {
  let queryString = "";

  if (page) {
    queryString += `_page=${page}`;
  }

  if (limit) {
    queryString += `&_limit=${limit}`;
  }

  if (tags?.length > 0) {
    queryString += tags.map((tag) => `&tags_like=${tag}`).join("");
  }

  if (search) {
    queryString += `&q=${search}`;
  }

  if (author) {
    queryString += `&author=${author}`;
  }

  const response = await axios.get(`/videos?${queryString}`);

  return {
    videos: response.data,
    total_count: response.headers["x-total-count"],
  };
};
